// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
// 站点管理
import Station from '@/views/station/Station';
// 桩管理
import Pile from '@/views/pile/Pile';
// 枪管理
import Gun from '@/views/gun/Gun';
// 机器信息管理
import Machine from '@/views/machine/Machine';
// 货道信息管理
import MachineAisle from '@/views/machine/MachineAisle';
/**
 * 订单管理
 */
import Charge from '@/views/order/Charge';
import WxCharge from '@/views/order/WxCharge';
import WhiteCharge from '@/views/order/WhiteCharge';
import TotalCharge from '@/views/order/TotalCharge';
import Recharge from '@/views/order/Recharge';
import Coupon from '@/views/system/Coupon';
import Backend from '@/views/backend/Backend';


import Price from '@/views/price/Price';

import Card from '@/views/card/Card';


// 交易订单
import Order from '@/views/pay/Order';
/**
 * 系统管理
 */
// 用户管理
import User from '@/views/system/User';

// 用户管理
import PlatformUser from '@/views/system/PlatformUser';

import WhiteUser from '@/views/system/WhiteUser.vue';


// 菜单管理
import Menu from '@/views/system/Menu';
// 角色管理
import Role from '@/views/system/Role';
// 权限管理
import Permission from '@/views/system/Permission';
/**
 * 支付管理
 */
// 支付配置信息
import MachineConfig from '@/views/machine/MachineConfig';
// 支付配置
import Config from '@/views/pay/Config';
/**
 * 数据监控
 */
// 监控查询
import druidLogin from '@/views/druid/login';

// 图表界面
import statistics from '@/views/charts/statistics';

// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [
          {
              path: '/station/Station',
              name: '站点管理',
              component: Station,
              meta: {
                  requireAuth: true
              }
          },
          {
            path: '/pile/Pile',
            name: '设备管理',
            component: Pile,
            meta: {
                requireAuth: true
            }
        },
        {
          path: '/backend/Backend',
          name: '后台充值管理',
          component: Backend,
          meta: {
              requireAuth: true
          }
      },
      {
          path: '/coupon/Coupon',
          name: '优惠卷管理',
          component: Coupon,
          meta: {
              requireAuth: true
          }
      },
        {
          path: '/gun/Gun',
          name: '枪管理',
          component: Gun,
          meta: {
              requireAuth: true
          }
          },
          {
            path: '/price/Price',
            name: '计费模型',
            component: Price,
            meta: {
                requireAuth: true
            }
        },
        {
          path: '/card/Card',
          name: '充值模型',
          component: Card,
          meta: {
              requireAuth: true
          }
      },
        {
          path: '/order/WxCharge',
          name: '微信充电订单',
          component: WxCharge,
          meta: {
              requireAuth: true
          }
      },
      {
          path: '/order/WhiteCharge',
          name: '后台充电订单',
          component: WhiteCharge,
          meta: {
              requireAuth: true
          }
      },
      {
          path: '/order/TotalCharge',
          name: '所有充电订单',
          component: TotalCharge,
          meta: {
              requireAuth: true
          }
      },

      {
        path: '/order/Charge',
        name: '余额充电订单',
        component: Charge,
        meta: {
            requireAuth: true
        }
    },
      {
          path: '/order/Recharge',
          name: '充值订单',
          component: Recharge,
          meta: {
              requireAuth: true
          }
      },



       {
            path: '/machine/Machine',
            name: '机器信息管理',
            component: Machine,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/machine/MachineAisle',
            name: '货道信息管理',
            component: MachineAisle,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/pay/Order',
            name: '交易订单',
            component: Order,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/User',
            name: '用户管理',
            component: User,
            meta: {
                requireAuth: true
            }
        },
        {
          path: '/system/PlatformUser',
          name: '用户管理',
          component: PlatformUser,
          meta: {
              requireAuth: true
          }
      },    {
          path: '/system/WhiteUser',
          name: '站点白名单用户管理',
          component: WhiteUser,
          meta: {
              requireAuth: true
          }
      },

        {
            path: '/system/Menu',
            name: '菜单管理',
            component: Menu,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Role',
            name: '角色管理',
            component: Role,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Permission',
            name: '权限管理',
            component: Permission,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/machine/MachineConfig',
            name: '支付配置信息',
            component: MachineConfig,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/pay/Config',
            name: '支付配置',
            component: Config,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/druid/login',
            name: '监控查询',
            component: druidLogin,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/charts/statistics',
            name: '数据可视化',
            component: statistics,
            meta: {
                requireAuth: true
            }
        }]
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js